import React from 'react';
import { Switch, Route, useParams, useRouteMatch, Link, useLocation } from 'react-router-dom';
import { Nav, Button, ButtonGroup } from 'react-bootstrap';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ReferenceLine, ResponsiveContainer } from 'recharts';
import { Checkbox, Label, IconButton, Persona, PrimaryButton, getTheme, Slider, Image, FontIcon, TextField, Dropdown, PersonaCoin, PersonaSize, ChoiceGroup, DefaultEffects, SearchBox } from '@fluentui/react';

import { Members } from './Members.js';
import { Projects } from './Projects.js';
import axios from 'axios';

import { socket } from '../socket.js';

function generateRandomNumber(n=5) {
  // Generate a random decimal between 0 (inclusive) and 1 (exclusive)
  const randomDecimal = Math.random();

  // Scale the random decimal to the range [1, 5] and round it to the nearest integer
  const randomNumber = Math.floor(randomDecimal * n);

  return randomNumber;
}

const workloadTemp = [
  {
    projectId: 1,
    month: 11,
    year: 2024,
    days: 4
  },
  {
    projectId: 1,
    month: 12,
    year: 2024,
    days: 4
  },
  {
    projectId: 1,
    month: 1,
    year: 2025,
    days: 4
  },
  {
    projectId: 2,
    month: 1,
    year: 2025,
    days: 4
  },
  {
    projectId: 2,
    month: 11,
    year: 2024,
    days: 4
  },
  {
    projectId: 2,
    month: 12,
    year: 2024,
    days: 4
  },
  {
    projectId: 2,
    month: 1,
    year: 2025,
    days: 4
  },
  {
    projectId: 3,
    month: 4,
    year: 2024,
    days: 3
  },
  {
    projectId: 3,
    month: 5,
    year: 2024,
    days: 1
  },
  {
    projectId: 3,
    month: 12,
    year: 2024,
    days: 5
  },
  {
    projectId: 3,
    month: 12,
    year: 2024,
    days: 2
  },
  {
    projectId: 3,
    month: 8,
    year: 2024,
    days: 3
  },
  {
    projectId: 4,
    month: 5,
    year: 2024,
    days: 1
  },
  {
    projectId: 4,
    month: 6,
    year: 2024,
    days: 5
  },
  {
    projectId: 4,
    month: 7,
    year: 2024,
    days: 2
  },
  {
    projectId: 4,
    month: 8,
    year: 2024,
    days: 3
  }
];

const MONTHS = ["January", "Februray", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

function daysInMonth(m, y){
  return 32 - new Date(y, m, 32).getDate();
}

function isWeekday(year, month, day) {
  var day = new Date(year, month, day).getDay();
  return day !== 0 && day !== 6;
}

function getWeekdaysInMonth(month, year) {
  var days = daysInMonth(month, year);
  var weekdays = 0;
  for(var i=0; i< days; i++) {
      if (isWeekday(year, month, i+1)) weekdays++;
  }
  return weekdays;
}

const sortObjAbc = (arr, key) => {
  arr.sort((a, b) => {
    const nameA = a[key].toUpperCase(); // ignore upper and lowercase
    const nameB = b[key].toUpperCase(); // ignore upper and lowercase
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
  
    // names must be equal
    return 0;
  })
  return arr;
}

export default function Team(props){

  const { path, url } = useRouteMatch();
  const { pathname } = useLocation();

  const [projects, setProjects] = React.useState([]);
  const [members, setMembers] = React.useState([]);
  const [workload, setWorkload] = React.useState([]);
  const [projectMembers, setProjectMembers] = React.useState([]);
  const [selectedMember, setSelectedMember] = React.useState('');
  const [probabilityFilter, setProbabilityFilter] = React.useState(0.5);
  const [numMonths, setNumMonths] = React.useState(12);
  const [openProjectId, setOpenProjectId] = React.useState(null);
  const [chartableType, setChartableTypes] = React.useState("Show All");
  const [isExpectedValue, toggleIsExpectedValue] = React.useState(false);
  const [filters, setFilters] = React.useState({name: '', pm: "", probability: "", member: ''});
  const [hideChartItems, setHideChartItems] = React.useState([]);
  const [isConnected, setIsConnected] = React.useState(socket.connected);
  // const [statusFilters, setStatusFilters] = React.useState({
  //   "Active": true,
  //   "On Hold": false,
  //   "Archived": false
  // });

  
  React.useEffect(() => {

    function onConnect() {
      console.log('connected');
      // socket.emit('user-join', localStorage.getItem('wlp-token'));
      setIsConnected(true);
    }

    function onDisconnect() {
      console.log('disconnect')
      // socket.emit('user-leave', localStorage.getItem('wlp-token'));
      setIsConnected(false);
    }

    socket.on('connect', onConnect);
    socket.on('disconnect', onDisconnect);

    // socket.on("user-join", (arg) => {
    //   console.log(arg);
    // });

    // socket.on("user-leave", (arg) => {
    //   console.log(arg);
    // });

    socket.on("update-workload", (arg) => {
      // console.log(arg); // world
      fetchWorkload();
    });

    return () => {
      socket.off('connect', onConnect);
      socket.off('disconnect', onDisconnect);
      // socket.off('foo', onFooEvent);
    };
  }, []);

  // initial fetch requests to build data
  const fetchMemberList = async () => {
    try {
      const members = await axios.get('/api/members');
      let m = members.data.members || [];
      setMembers(sortObjAbc(m, 'name'));
      if(!selectedMember && m.length){
        console.log('set the member');
        setSelectedMember(m[0]);
      }
    } catch(err) {
      console.log(err)
      setMembers([]);
    }
  }

  const fetchProjects = async () => {
    try {
      const projects = await axios.get('/api/projects');
      let p = projects.data.projects || [];
      
      setProjects(sortObjAbc(p, 'name'));
    } catch(err) {
      console.log(err);
      setProjects([]);
    }
  }

  const fetchWorkload = async (from, to) => {
    try {
      const workload = await axios.get('/api/workload');
      setWorkload(workload.data.workload || []);
    } catch(err) {
      console.log(err);
      setWorkload([]);
    }
  }

  const fetchProjectMembers = async () => {
    try {
      const projectMembers = await axios.get('/api/project-members');
      setProjectMembers(projectMembers.data.projectMembers || []);
    } catch(err){
      console.log(err);
      setProjectMembers([]);
    }
  }

  React.useEffect(() => {
    fetchMemberList();
    fetchProjects();
    fetchWorkload();
    fetchProjectMembers();
  }, []);



  const updateWorkloadDatabase = async (data) => {
    // console.log(data);
    try {
      const res = await axios.post('/api/workload', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('wlp-token')}`,
        },
      });
      socket.emit('updates-made');
    } catch(err){
      console.log(err);
    }
  }

  const months = React.useMemo(() => {
    let currentMonth = new Date().getMonth() + 1;
    let currentYear = new Date().getFullYear();
    let holder = [];
    for(let i = 1; i <= numMonths; i++){
      holder.push({
        fullLabel: `${MONTHS[currentMonth - 1].slice(0,3)} ${currentYear}`,
        year: currentYear,
        month: currentMonth,
        monthLabel: MONTHS[currentMonth - 1]
      });
      if(currentMonth === 12){
        currentMonth = 1;
        currentYear = currentYear + 1;
      } else {
        currentMonth = currentMonth + 1;
      }
    }
    return holder;
  }, [numMonths]);

  const changeMemberWorkload = (member_id, project_id, month, year, newValue) => {
    setWorkload(prev => {
      if(!prev.find(load => load.member_id === member_id && load.project_id === project_id && load.month === month && load.year == year)){
        updateWorkloadDatabase({project_id, member_id, month, year, days: newValue});
        return prev.concat({project_id, member_id, month, year, days: newValue});
      }
      return prev.map(load => {
        if(load.member_id === member_id && load.project_id === project_id && load.month === month && load.year == year){
          updateWorkloadDatabase({...load, days: newValue});
          return {
            ...load,
            days: newValue
          }
        }
        return load;
      })
    })
  };

  const projectsJoinMembers = React.useMemo(() => {
    let p = projects.filter(p => p.status !== 'Archived').map(project => {
      return {
        ...project,
        members: members
        .filter(mem => projectMembers.find(p => p.project_id === project.id && mem.id === p.member_id))
        .map(mem => {
          return {
            ...mem,
            workload: workload.filter(el => el.member_id === mem.id)
          }
        })
      }
    });
    if(filters.name){
      p = p.filter(el => el.name.toLowerCase().includes(filters.name.toLowerCase()));
    }
    if(filters.pm){
      p = p.filter(el => el.pm === filters.pm);
    }
    if(filters.member){
      p = p.filter(el => el.members.find(m => m.id === filters.member));
      p = p.map(p => {
        return {
          ...p,
          members: p.members.filter(mem => mem.id === filters.member)
        }
      })
    }
    return p;
  }, [members, projects, workload, projectMembers, filters]);

  const countMemberDaysPerMonth = (project, monthYear) => {
    let val = 0;
    project.members.forEach(mem => {
      mem.workload.forEach(load => {
        if(load.month === monthYear.month && load.year == monthYear.year && load.project_id === project.id){
          val += parseFloat(load.days);
        }
      })
    })
    return val;
  }

  const [chartData, projectKeys] = React.useMemo(() => {
    if(!selectedMember) return [];
    const projectLinks = projectMembers.filter(el => el.member_id === selectedMember.id);
    const memberProjects = projects.filter(p => projectLinks.find(el => el.project_id === p.id))
    .filter(project => {
      if(project.status === "Archived") return false;
      if(project.type === 'Other' && chartableType === 'Projects Only'){
        return false;
      } else {
        if(probabilityFilter <= project.probability){
          return true;
        } else {
          return false;
        }
      }
    })
    .map(p => {
      let load = months.map(mon => {
        let { days } = workload.find(el => el.month === mon.month && el.year == mon.year && el.project_id === p.id && el.member_id === selectedMember.id) || {days: ''};
        return {[`${p.name}`]: days, ...mon, days};
      })
      return {
        ...p,
        workload: load
      }
    });

    const data = months.map((m, index) => {
      let trace = {
        name: `${m.fullLabel}`
      };
      memberProjects.forEach(series => {
        trace[series.name] = isExpectedValue ? (series.workload[index].days || 0) * series.probability : (series.workload[index].days || 0)
      })
      return trace;
    });

    return [data, memberProjects];
  }, [projects, projectMembers, months, selectedMember, workload, chartableType, probabilityFilter, isExpectedValue]);

  const handleLegendClick = ({dataKey}) => {
    setHideChartItems(prev => {
      return prev.includes(dataKey) ? prev.filter(el => el !== dataKey) : prev.concat(dataKey);
    })
  }

  return <div style={{marginTop: 32}}>
    <Nav variant="tabs" activeKey={pathname} style={{padding: '0 2em'}}>
      <Nav.Item>
        <Image style={{marginLeft: 32, marginRight: 32}} height={40} src={'https://compassrm.com/wp-content/uploads/2017/10/compass_logo.jpg'} />
      </Nav.Item>
      <Nav.Item>
        <Nav.Link eventKey={`${url}`} as={Link} to={`${url}`}>Workload Planner</Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link eventKey={`${url}/members`} as={Link} to={`${url}/members`}>Members</Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link eventKey={`${url}/projects`} as={Link} to={`${url}/projects`}>Projects</Nav.Link>
      </Nav.Item>
    </Nav>
    <div style={{margin: '2em'}}>
      <Switch>
        <Route exact path={path}>
        <div className='mt-4 mb-4'>
            <h2 className='mb-4'>
              Individual Workload - <span style={{border: '1px solid #dee2e6', padding: '4px 8px 4px 16px', borderRadius: 4, boxShadow: DefaultEffects.elevation4, cursor: 'pointer'}} onClick={() => {
                document.getElementById('trigger-menu').click();
              }}>
                <span className='hover-name'>{selectedMember && selectedMember.name}</span>
                <IconButton
                  // ref={dropMenuRef}
                  id="trigger-menu"
                  styles={{menuIcon: {fontSize: 24, fontWeight: 'bold'}}}
                  menuProps={{
                    items: members.map(mem => ({key: mem.id, text: mem.name, onClick: () => setSelectedMember(mem)}))}} />
              </span>
            </h2>
            <div style={{boxShadow: DefaultEffects.elevation8}}>
              <div style={{display: 'flex', gap: '2em', padding: '1em', borderBottom: '2px solid #dee2e6', background: '#f8f9fa'}}>
                <div>
                  <Label>Chart Method</Label>
                  <ButtonGroup size="sm">
                    <Button variant="light" active={isExpectedValue} onClick={() => toggleIsExpectedValue(true)}>Expected Value</Button>
                    <Button variant="light" active={!isExpectedValue} onClick={() => toggleIsExpectedValue(false)}>Raw Value</Button>
                  </ButtonGroup>
                </div>
                <div>
                  <Label>Time Frame</Label>
                  <ButtonGroup size="sm">
                    <Button variant="light" active={numMonths === 3} onClick={() => setNumMonths(3)}>3 Months</Button>
                    <Button variant="light" active={numMonths === 6} onClick={() => setNumMonths(6)}>6 Months</Button>
                    <Button variant="light" active={numMonths === 12} onClick={() => setNumMonths(12)}>12 Months</Button>
                  </ButtonGroup>
                </div>
                <div>
                  <Label>Chart Items</Label>
                  <ButtonGroup size="sm" style={{marginBottom: '1em'}}>
                    <Button variant="light" active={chartableType === "Show All"} onClick={() => setChartableTypes("Show All")}>Show All</Button>
                    <Button variant="light" active={chartableType === "Projects Only"} onClick={() => setChartableTypes("Projects Only")}>Projects Only</Button>
                  </ButtonGroup>
                </div>
                {/* <div>
                  <Label>Project Status</Label>
                  <ButtonGroup size="sm" style={{marginBottom: '1em'}}>
                    {
                      Object.keys(statusFilters).map(key => {
                        let variant = key === "Active" ? 'success' : key === 'On Hold' ? 'warning' : 'light';
                        return <Button 
                          key={key} 
                          variant={statusFilters[key] ? variant : 'light'}
                          active={statusFilters[key]} 
                          onClick={() => setStatusFilters(prev => ({...prev, [key]: !prev[key]}))}>{key}</Button>
                      })
                    }
                  </ButtonGroup>
                </div> */}
                <div style={{width: 300}}>
                  <Label>Probability</Label>
                  <Slider 
                    value={probabilityFilter}
                    min={0}
                    max={1}
                    step={0.05} 
                    valueFormat={(val) => `${Math.round(val * 100)}%`}
                    onChange={(val) => setProbabilityFilter(val)} 
                    showValue />
                </div>
              </div>
              <div style={{height: 600}}>
                <ResponsiveContainer width="100%">
                  <BarChart
                    height={500}
                    data={chartData}
                    margin={{
                      top: 40,
                      right: 40,
                      left: 40,
                      bottom: 40,
                    }}
                  >
                    <CartesianGrid strokeDasharray="3 3" vertical={false} />
                    <XAxis dataKey="name" includeHidden />
                    <YAxis name='Days' label={{ value: 'Days', angle: -90, position: 'insideLeft' }} domain={[0,20]} />
                    <Tooltip />
                    <Legend 
                      layout='vertical'
                      formatter={(val, entry) => {
                        return <span style={{color: entry.inactive ? '#ccc' : '#333'}}>{val}</span>
                      }}
                      verticalAlign='middle' 
                      align='right' 
                      onClick={handleLegendClick}
                    />
                    <ReferenceLine isFront={true} y={15}  stroke={getTheme().palette.themePrimary} strokeDasharray="3 3" />
                    {
                      projectKeys?.map(({id, name, color, probability, type}) => {
                        if(type === 'Project'){
                          return <Bar
                            key={id}
                            hide={hideChartItems.includes(name)}
                            dataKey={name}
                            name={name} 
                            fill={color} 
                            fillOpacity={0.75}
                            stackId={'a'} />
                        }
                      })
                    }
                    {
                      projectKeys?.map(({id, name, color, probability, type}) => {
                        if(type === 'Other'){
                          return <Bar
                            key={id}
                            hide={hideChartItems.includes(name)}
                            dataKey={name}
                            name={name} 
                            fill={color} 
                            fillOpacity={0.75}
                            stackId={'a'} />
                        }
                      })
                    }
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>
          <h2 className='mb-4'>Workload Planner</h2>
          <div style={{boxShadow: DefaultEffects.elevation8, width: 'max-content'}}>
            <div style={{display: 'flex', gap: '2em', padding: '1em', borderBottom: '1px solid #dee2e6', background: '#f8f9fa'}}>
              <div>
                <Label>Time Frame</Label>
                <ButtonGroup size="sm">
                  <Button variant="light" active={numMonths === 3} onClick={() => setNumMonths(3)}>3 Months</Button>
                  <Button variant="light" active={numMonths === 6} onClick={() => setNumMonths(6)}>6 Months</Button>
                  <Button variant="light" active={numMonths === 12} onClick={() => setNumMonths(12)}>12 Months</Button>
                </ButtonGroup>
              </div>
              <div style={{width: 240}}>
                <Label>Filter by Project Name</Label>
                <SearchBox
                  value={filters.name} 
                  onChange={(e, v) => setFilters(prev => ({...prev, name: v}))} />
              </div>
              <div style={{width: 240}}>
                <Label>Filter by PM</Label>
                <Dropdown
                  selectedKey={filters.pm}
                  options={members.map(m => ({key: m.name, text: m.name}))}
                  onChange={(e, o) => setFilters(prev => ({...prev, pm: o.key}))} />
              </div>
              <div style={{width: 240}}>
                <Label>Filter by Individual</Label>
                <Dropdown
                  selectedKey={filters.member}
                  options={members.map(m => ({key: m.id, text: m.name}))}
                  onChange={(e, o) => setFilters(prev => ({...prev, member: o.key}))} />
              </div>
              <div style={{alignItems: 'flex-end', display: 'flex'}}>
                <Button disabled={!filters.name && !filters.pm && !filters.member} size='sm' variant='outline-danger' onClick={() => setFilters({pm: '', name: ''})}>Clear Filters</Button>
              </div>
            </div>
            <table className='table table-sm table-bordered table-hover' style={{maxHeight: 600, overflowY: 'auto', width: 'max-content', maxWidth: '100%', overflow: 'scroll'}}>
              <thead>
                <tr>
                  <th style={{background: '#fff', position: 'sticky', left: 0, top: 0, zIndex: 3}}>
                    Projects
                  </th>
                  <th style={{background: '#fff', position: 'sticky', top: 0, zIndex: 2, width: 32}}>PM</th>
                  <th style={{background: '#fff', position: 'sticky', top: 0, zIndex: 2, width: 100}}>Probability</th>
                  {
                    months.map(m => <th style={{background: '#fff', width: 100, position: 'sticky', top: 0, zIndex: 2}} key={m.fullLabel}><div style={{textAlign: 'center'}}>{m.monthLabel.slice(0,3)}</div><div style={{textAlign: 'center'}}>{m.year}</div></th>)  
                  }
                </tr>
              </thead>
              <tbody>
                {
                  projectsJoinMembers.map(project => {
                    if(project.type !== 'Project') return;
                    return <React.Fragment key={project.id}>
                      <tr style={{filter: openProjectId && openProjectId !== project.id ? 'blur(2px)' : 'none', opacity: openProjectId && openProjectId !== project.id ? '0.35' : '1'}}>
                        <td style={{position: 'sticky', left: 0, zIndex: 2, background: '#fff'}}> 
                          <div style={{display: 'flex', alignItems: 'center'}}>
                            <IconButton
                              iconProps={{iconName: openProjectId === project.id ? "ChevronDown" : "ChevronRight"}} 
                              onClick={() => setOpenProjectId(prev => prev === project.id ? null : project.id)} />
                            <FontIcon 
                              iconName='StatusCircleInner'
                              style={{color: project.color, marginRight: 8}} />
                            {project.name}
                          </div>
                        </td>
                        <td valign='middle' align='center' style={{verticalAlign: 'middle'}}>
                          <PersonaCoin size={PersonaSize.size24} text={project.pm}/>
                        </td>
                        <td align='center' style={{verticalAlign: 'middle'}}>{Math.round(project.probability * 100) + '%'}</td>
                        {
                          months.map(m => <td align='center' style={{width:100, verticalAlign: 'middle'}} key={m.fullLabel}>
                            {countMemberDaysPerMonth(project, m)}
                          </td>)  
                        }
                      </tr>
                      {
                        project.id === openProjectId && project.members.map(member => {
                          return <tr key={member.id}>
                            <td align='end' style={{position: 'sticky', left: 0, zIndex: 2, background: '#fff', verticalAlign: 'middle'}}>{member.name}</td>
                            <td></td>
                            <td></td>
                            {
                              months.map(m => {
                                let { days } = member.workload.find(el => el.month === m.month && el.year == m.year && el.project_id === project.id) || {days: ''};
                                return <th style={{width:100}} key={m.fullLabel}>
                                  <TextField onChange={(e, val) => changeMemberWorkload(member.id, project.id, m.month, m.year, val)} value={days} styles={{field: {textAlign: 'center'}}} autoComplete='off' borderless />
                                </th>
                              }
                              )  
                            }
                          </tr>
                        })
                      }
                    </React.Fragment>
                  })
                }
                <tr>
                  <th style={{position: 'sticky', left: 0, zIndex: 9999}} colSpan={months.length + 3}>Other</th>
                  {/* <th colSpan={months.length + 2}></th> */}
                </tr>
                {
                  projectsJoinMembers.map(project => {
                    if(project.type !== 'Other') return;
                    return <React.Fragment key={project.id}>
                      <tr style={{filter: openProjectId && openProjectId !== project.id ? 'blur(2px)' : 'none', opacity: openProjectId && openProjectId !== project.id ? '0.35' : '1'}}>
                        <td style={{position: 'sticky', left: 0, zIndex: 9999}}> 
                          <div style={{display: 'flex', alignItems: 'center'}}>
                            <IconButton
                              iconProps={{iconName: "ChevronDown"}} 
                              onClick={() => setOpenProjectId(prev => prev === project.id ? null : project.id)} />
                            <FontIcon 
                              iconName='StatusCircleInner'
                              style={{color: project.color, marginRight: 8}} />
                            {project.name}
                          </div>
                        </td>
                        <td valign='center'>{project.pm}</td>
                        <td align='center'>{Math.round(project.probability * 100) + "%"}</td>
                        {
                          months.map(m => <td align='center' style={{width:100}} key={m.fullLabel}>
                            {countMemberDaysPerMonth(project, m)}
                          </td>)  
                        }
                      </tr>
                      {
                        project.id === openProjectId && project.members.map(member => {
                          return <tr key={member.id}>
                            <td align='end' style={{verticalAlign: 'middle'}}>{member.name}</td>
                            <td></td>
                            <td></td>
                            {
                              months.map(m => {
                                let { days } = member.workload.find(el => el.month === m.month && el.year == m.year && el.project_id === project.id) || {days: ''};
                                return <th style={{width:100}} key={m.fullLabel}>
                                  <TextField onChange={(e, val) => changeMemberWorkload(member.id, project.id, m.month, m.year, val)} value={days} styles={{field: {textAlign: 'center'}}} autoComplete='off' borderless />
                                </th>
                              }
                              )  
                            }
                          </tr>
                        })
                      }
                    </React.Fragment>
                  })
                }
              </tbody>
            </table>
          </div>



          <h2 className='mb-4'>Individual Workloads</h2>
          <div style={{boxShadow: DefaultEffects.elevation8, width: 'max-content'}}>
            {/* <div style={{display: 'flex', gap: '2em', padding: '1em', borderBottom: '1px solid #dee2e6', background: '#f8f9fa'}}>
              <div>
                <Label>Time Frame</Label>
                <ButtonGroup size="sm">
                  <Button variant="light" active={numMonths === 3} onClick={() => setNumMonths(3)}>3 Months</Button>
                  <Button variant="light" active={numMonths === 6} onClick={() => setNumMonths(6)}>6 Months</Button>
                  <Button variant="light" active={numMonths === 12} onClick={() => setNumMonths(12)}>12 Months</Button>
                </ButtonGroup>
              </div>
              <div style={{width: 240}}>
                <Label>Filter by Project Name</Label>
                <SearchBox
                  value={filters.name} 
                  onChange={(e, v) => setFilters(prev => ({...prev, name: v}))} />
              </div>
              <div style={{width: 240}}>
                <Label>Filter by PM</Label>
                <Dropdown
                  selectedKey={filters.pm}
                  options={members.map(m => ({key: m.name, text: m.name}))}
                  onChange={(e, o) => setFilters(prev => ({...prev, pm: o.key}))} />
              </div>
              <div style={{width: 240}}>
                <Label>Filter by Individual</Label>
                <Dropdown
                  selectedKey={filters.member}
                  options={members.map(m => ({key: m.id, text: m.name}))}
                  onChange={(e, o) => setFilters(prev => ({...prev, member: o.key}))} />
              </div>
              <div style={{alignItems: 'flex-end', display: 'flex'}}>
                <Button disabled={!filters.name && !filters.pm && !filters.member} size='sm' variant='outline-danger' onClick={() => setFilters({pm: '', name: ''})}>Clear Filters</Button>
              </div>
            </div> */}
            <table className='table table-sm table-bordered table-hover' style={{maxHeight: 600, overflowY: 'auto', width: 'max-content', maxWidth: '100%', overflow: 'scroll'}}>
              <thead>
                <tr>
                  <th style={{background: '#fff', position: 'sticky', left: 0, top: 0, zIndex: 3}}>
                    Name
                  </th>
                  <th style={{background: '#fff', position: 'sticky', top: 0, zIndex: 2, width: 32}}>Project</th>
                  <th style={{background: '#fff', position: 'sticky', top: 0, zIndex: 2, width: 100}}>Probability</th>
                  {
                    months.map(m => <th style={{background: '#fff', width: 100, position: 'sticky', top: 0, zIndex: 2}} key={m.fullLabel}><div style={{textAlign: 'center'}}>{m.monthLabel.slice(0,3)}</div><div style={{textAlign: 'center'}}>{m.year}</div></th>)  
                  }
                </tr>
              </thead>
              <tbody>
                {
                  members.map(member => {
                    // console.log(member);
                    let workload = [...projectsJoinMembers];

                    workload = workload.filter(el => el.members.find(m => m.id === member.id));
                    workload = workload.map(p => {
                      return {
                        ...p,
                        members: p.members.filter(mem => mem.id === member.id)
                      }
                    });

                    
                    
                    return workload.map(work => {
                      return <tr key={member.id}>
                        <td style={{position: 'sticky', left: 0, zIndex: 2, background: '#fff'}}>{member.name}</td>
                        <td>{work.name}</td>
                        <td>{Math.round(work.probability * 100) + '%'}</td>
                        {
                          months.map(m => <td align='center' style={{width:100, verticalAlign: 'middle'}} key={m.fullLabel}>
                            {countMemberDaysPerMonth(work, m)}
                          </td>)  
                        }
                      </tr>
                    })
                  })
                }
              </tbody>
            </table>
          </div>









        </Route>
        <Route path={`${path}/members`}>
          <Members members={members} setMembers={setMembers} />
        </Route>
        <Route path={`${path}/projects`}>
          <Projects 
            projects={projects} 
            setProjects={setProjects} 
            members={members} 
            setMembers={setMembers}
            fetchProjects={fetchProjects}
            fetchProjectMembers={fetchProjectMembers} 
            projectMembers={projectMembers} />
        </Route>
      </Switch>
    </div>
  </div>
}